<!-- <div class="d-flex align-items-center justify-content-between">
  <div class="fs-1">
        Module public
  </div>
  <div class="d-flex">
        <div class="dropdown">
              <button type="button" class="btn p-0 dropdown-toggle hide-arrow"
                    data-bs-toggle="dropdown">{{menu.titre}}</button>
              <div class="dropdown-menu">
                    <a routerLinkActive="bg-primary text-white"  *ngFor="let one_menu of menu.items" [routerLink]="[one_menu.path]" class="dropdown-item" >
                          {{one_menu.libelle}}
                    </a>
              </div>
        </div>
  </div>
</div> -->
<div>
      <router-outlet></router-outlet>
</div>
